export default {"src":"/login-app/[GIT_HASH]/_next/static/media/expand_less.22b5f21e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};